import type { SalesHierarchyModel } from "@/models/pipeline";
import type { Department, DepartmentSelectOption } from "@/types/appData";
import { naturalSort } from "@/helpers/sorting";

export const buildDepartmentSelectOptionsFromHierarchy = (
  hierarchy: SalesHierarchyModel[],
  phoenixDepartments: Department[]
): DepartmentSelectOption[] => {
  if (!hierarchy.length) {
    return phoenixDepartments
      .filter((dept) => dept?.departmentId != null && dept?.department != null)
      .map((dept) => ({
        value: dept.departmentId,
        label: dept.department,
      }))
      .sort((a, b) => naturalSort(a.label, b.label));
  }

  const phoenixById = new Map<string, string>();
  for (const dept of phoenixDepartments) {
    if (dept?.departmentId != null && dept?.department != null) {
      phoenixById.set(dept.departmentId, dept.department);
    }
  }

  const hierarchyById = new Map<string, string>();
  for (const row of hierarchy) {
    if (!row?.departmentId) continue;
    if (hierarchyById.has(row.departmentId)) continue;
    const label = row.departmentName?.trim() || phoenixById.get(row.departmentId) || row.departmentId;
    hierarchyById.set(row.departmentId, label);
  }

  return Array.from(hierarchyById.entries())
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => naturalSort(a.label, b.label));
};
